import { toLocalizedRiotUrl } from './../utils/language';
import { logger } from 'packages';
import { isServer } from 'tradera-utils/nextjs';

let history;

if (!isServer) {
    import('../../app_react/history')
        .then(module => {
            history = module.default;
            return history;
        })
        .catch(logger);
}

const goToStart = function() {
    history.push(toLocalizedRiotUrl('/selling/'));
};

const goToSummary = function(draftId) {
    history.push(toLocalizedRiotUrl('/selling/summary/' + draftId));
};

const goToPublished = function(itemId) {
    history.push(toLocalizedRiotUrl('/selling/published/' + itemId));
};

const setDraftUrlWithoutReload = function(draftId) {
    window.history.replaceState(
        {},
        document.title,
        toLocalizedRiotUrl('/selling/draft/' + draftId)
    );
};

export default {
    goToStart,
    goToSummary,
    goToPublished,
    setDraftUrlWithoutReload
};
